/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ListingState } from './ListingState';
import {
    ListingStateFromJSON,
    ListingStateFromJSONTyped,
    ListingStateToJSON,
} from './ListingState';
import type { MlsNames } from './MlsNames';
import {
    MlsNamesFromJSON,
    MlsNamesFromJSONTyped,
    MlsNamesToJSON,
} from './MlsNames';

/**
 * 
 * @export
 * @interface AutoCompleteListingAddress
 */
export interface AutoCompleteListingAddress {
    /**
     * 
     * @type {string}
     * @memberof AutoCompleteListingAddress
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AutoCompleteListingAddress
     */
    address: string;
    /**
     * 
     * @type {string}
     * @memberof AutoCompleteListingAddress
     */
    kind?: AutoCompleteListingAddressKindEnum;
    /**
     * 
     * @type {string}
     * @memberof AutoCompleteListingAddress
     */
    dispositionId?: string;
    /**
     * 
     * @type {MlsNames}
     * @memberof AutoCompleteListingAddress
     */
    mlsNames?: MlsNames;
    /**
     * 
     * @type {Date}
     * @memberof AutoCompleteListingAddress
     */
    highestAndBestDeadline?: Date;
    /**
     * 
     * @type {number}
     * @memberof AutoCompleteListingAddress
     */
    listPrice?: number;
    /**
     * 
     * @type {ListingState}
     * @memberof AutoCompleteListingAddress
     */
    listingStatus?: ListingState;
}


/**
 * @export
 */
export const AutoCompleteListingAddressKindEnum = {
    Listing: 'listing',
    Disposition: 'disposition'
} as const;
export type AutoCompleteListingAddressKindEnum = typeof AutoCompleteListingAddressKindEnum[keyof typeof AutoCompleteListingAddressKindEnum];


/**
 * Check if a given object implements the AutoCompleteListingAddress interface.
 */
export function instanceOfAutoCompleteListingAddress(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "address" in value;

    return isInstance;
}

export function AutoCompleteListingAddressFromJSON(json: any): AutoCompleteListingAddress {
    return AutoCompleteListingAddressFromJSONTyped(json, false);
}

export function AutoCompleteListingAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutoCompleteListingAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'address': json['address'],
        'kind': !exists(json, 'kind') ? undefined : json['kind'],
        'dispositionId': !exists(json, 'disposition_id') ? undefined : json['disposition_id'],
        'mlsNames': !exists(json, 'mls_names') ? undefined : MlsNamesFromJSON(json['mls_names']),
        'highestAndBestDeadline': !exists(json, 'highest_and_best_deadline') ? undefined : (new Date(json['highest_and_best_deadline'])),
        'listPrice': !exists(json, 'list_price') ? undefined : json['list_price'],
        'listingStatus': !exists(json, 'listing_status') ? undefined : ListingStateFromJSON(json['listing_status']),
    };
}

export function AutoCompleteListingAddressToJSON(value?: AutoCompleteListingAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'address': value.address,
        'kind': value.kind,
        'disposition_id': value.dispositionId,
        'mls_names': MlsNamesToJSON(value.mlsNames),
        'highest_and_best_deadline': value.highestAndBestDeadline === undefined ? undefined : (value.highestAndBestDeadline.toISOString()),
        'list_price': value.listPrice,
        'listing_status': ListingStateToJSON(value.listingStatus),
    };
}

